// extracted by mini-css-extract-plugin
module.exports = {"articleContainer":"BlogArticle_articleContainer__PES_G","subtitle":"BlogArticle_subtitle__tmoQV"};